import React, { Component} from "react";
import Cookies from "js-cookie";
import ServiceApi from "../../services/ServiceApi";
import { Select, DatePicker, ConfigProvider, notification, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import moment from "moment";

const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const { REACT_APP_URL_API } = process.env;
const domainReport = REACT_APP_URL_API.replace("/api","/ReportTemplate");

class FaultMonthlyReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CheckDisplayJobType: false,
      CheckDisplayPayType: true,
      areaId: null,
      vendorId: null,
      vendor: null,
      vendorName: null,
      vendorList: [],
      jobtypelist: "",
      payTypeId: "NULL",
      startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      downloadReportUrl: "",
      downloadReportMessage: "",
      optionJobType: "none",
      actionListJobType: "arrow down",
      statusCheckJobTypeListAll: "No",
      statusCheckActive: "",
      url: [],
      loading: "none",
      periodList: [],
      periodId: "",
      periodName: "",
      approvStatus: 0,

      downloadMessage: "block",
      refDocNo: "",
      data_job_type : [] ,
      checkbox_all : false,
      jobType: []
    };
    this.setArea = this.setArea.bind(this);
  }

  async componentDidMount() {

    if (
      this.props.reportType === "Form_For_MA_Fiber_Subcontractor" ||
      this.props.reportType === "Fault_Monthly_Material_Report" ||
      this.props.reportType === "Maintenance_Location_Report"
    ) {
      this.setState({ CheckDisplayJobType: false });
    } else {
      this.setState({ CheckDisplayJobType: true });
    }

    if (this.props.reportType === "Maintenance_Location_Report") {
      this.setState({ CheckDisplayPayType: false });
    }

    if ((this.props.reportType === "Form_For_MA_Fiber_Subcontractor") || (this.props.reportType === "Fault_Monthly_Report")){
      let type_report = "TRS";
      if(this.props.reportType === "Fault_Monthly_Report"){
        type_report = "BTS";
      }
      ServiceApi.post("get_period_report", {
        sql_where: ' and type_report = "'+ type_report +'"'
      })
      .then((res) => {
        //console.log('periodList:',res.data.data)
        this.setState({ periodList: res.data.data});
      })
      .catch((e) => {
        console.log("error loading vendor", e);
      });
    }

    this.getJobType();
  }

  getJobType = () => {
    ServiceApi.post("V4/get_job_type", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      pk_id: null,
      fk_id: null,
      is_active: 1,
      effective: 1,
      sql_where: null,
      UserName: Cookies.get("username")
    })
      .then((res) => {
        //this.props.jobType = res.data.data;
        this.setState({jobType:res.data.data,data_job_type:res.data.data});
      })
      .catch((e) => {
        console.log("error loading job type", e);
      });
    this.state.data_job_type.forEach(element => element["checkbox"] = false);
  }
  setArea = (value) => {
    this.setState({ areaId: value });

    ServiceApi.post("master_data/GetTeamGroupAreaReport", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      team_group_duty_code: "O",
      area_code: value,
    })
      .then((res) => {
        this.setState({ vendorList: res.data.list });
      })
      .catch((e) => {
        console.log("error loading vendor", e);
      });

  };

  setVendor = (value) => {
    const s = value.split("_");
    if (s[0] !== "undefined" && s[1] !== "undefined") {
      this.setState({ vendorId: s[0], vendorName: s[1] });
    }
  };

  setPayType = (value) => {
    this.setState({ payTypeId: value });
  };

  setStartDate = (value) => {
    this.setState({ startDate: value });
  };

  setEndDate = (value) => {
    this.setState({ endDate: value });
  };

  setPeriodReport = (value) => {
    var period = value.split("_");
    this.setState({periodId: period[0], periodName: period[1] });
  }

  notify = (type, title, msg) => {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  };

  clearSelect = () => {
    this.setState({
      areaId: null,
      vendorId: null,
      vendorName: null,
      vendorList: [],
      jobTypeId: null,
      payTypeId: null,
    });
  };

  genExcel = () => {
    this.setState({
      downloadMessage: "none"
    })
    let invalid = 0;

    if (this.state.vendorId === null) {
      invalid = 1;
      this.notify("info", "Informaton", "Please select vendor.");
    }

    if ((this.props.reportType === "Form_For_MA_Fiber_Subcontractor") || (this.props.reportType === "Fault_Monthly_Report")) {
      if(this.state.periodId == ""){
        invalid = 1;
        this.notify("info", "Informaton", "Please select period before.");
      }
    }

    if (invalid === 0) {
      // check status report approve can re gen report
      if ((this.props.reportType === "Form_For_MA_Fiber_Subcontractor") || (this.props.reportType === "Fault_Monthly_Report")) {
        let str_where_check = "";
        if(this.props.reportType === "Fault_Monthly_Report"){
          if((this.state.jobtypelist == "63,64") || (this.state.jobtypelist == "63") || (this.state.jobtypelist == 64)){
            str_where_check = " and ((job_type_id = '63,64') || (job_type_id = '63') || (job_type_id = '64'))";
          } else {
            str_where_check = " and ((job_type_id != '63,64') and (job_type_id != '63') and (job_type_id != '64'))";
          }
        }

        ServiceApi.post("count_approve_report_file_list", {
          str_where: "company_id = "+ Cookies.get("companyid") +
                  " and operator_id = "+ Cookies.get("operator_id") +
                  " and project_id = "+ Cookies.get("project_id") +
                  " and area_id = '" + this.state.areaId + "'" +
                  " and vendor_id = " + this.state.vendorId +
                  " and period_id = " + this.state.periodId + str_where_check
        })
          .then((res) => {
            if (res.data.result.code === "P") {

              if(res.data.data[0].num == 0){
                console.log('peroid name:'+this.state.periodName);
                // Gen report first start
                // Gen new report
                let api = "get_job_summary_report_bts";
                if (this.props.reportType === "Form_For_MA_Fiber_Subcontractor") {
                  api = "get_job_summary_report";
                }
                this.setState({loading: "block"})
                ServiceApi.post(api, {
                  company_id: Cookies.get("companyid"),
                  operator_id: Cookies.get("operator_id"),
                  project_id: Cookies.get("project_id"),
                  area_id: this.state.areaId,
                  job_type_id: this.state.jobtypelist,
                  pay_type_id: this.state.payTypeId,
                  team_group_id: this.state.vendorId,
                  start_date: this.state.startDate + " 00:00:00",
                  end_date: this.state.endDate + " 23:59:59",
                  vendor_name: this.state.vendorName,
                  peroid_name: this.state.periodName
                })
                  .then((res) => {
                    if (res.data.result.code === "P") {
                      console.log('refDocNo='+res.data.result.showText);
                      let doc = res.data.result.showText.split(",");
                      let filename = res.data.result.description.split(",");

                      doc.map((ReferDocNo,index) => {

                        this.setState({
                          url: res.data.result.value.split(","),
                          downloadReportMessage: "",
                          loading: "none",
                          downloadMessage: "block",
                          refDocNo: ReferDocNo//res.data.result.showText
                        });

                        // keep log gen report
                        let tmpZone = [];
                        let zoneCode = "";
                        let file = "";
                        if ((this.props.reportType === "Form_For_MA_Fiber_Subcontractor") || (this.props.reportType === "Fault_Monthly_Report")) {
                          let type_report = "TRS";
                          let tmpFile = filename[index].split(":");

                          if(this.props.reportType === "Fault_Monthly_Report"){
                            type_report = "BTS";
                            zoneCode = "";
                            file = filename[index];
                          }else{
                            zoneCode = tmpFile[0];
                            file = tmpFile[1];
                          }

                          ServiceApi.post("ins_approve_report_file_list", {
                            company_id: Cookies.get("companyid"),
                            operator_id: Cookies.get("operator_id"),
                            project_id: Cookies.get("project_id"),
                            area_id: this.state.areaId,
                            job_type_id: this.state.jobtypelist,
                            pay_type_id: this.state.payTypeId,
                            team_group_id: this.state.vendorId,
                            start_date: this.state.startDate,
                            end_date: this.state.endDate,
                            period_id: this.state.periodId,
                            file_name: file,
                            create_user: Cookies.get("username"),
                            type_report: type_report,
                            ref_doc_no: ReferDocNo,
                            zone_code: zoneCode
                          })
                            .then((res) => {
                              console.log("keep gen report to report list:");
                            })
                            .catch((e) => {
                              console.log("error check approve report file list", e);
                            });
                        }
                      })//close loop doc
                    } else {
                      this.notify(
                        "info",
                        "Informaton",
                        "Is Empty. " + res.data.result.value
                      );
                      this.setState({ downloadReportMessage: res.data.result.value,loading: "none",downloadMessage: "block" });

                    }
                  })
                  .catch((e) => {
                    console.log("error generating report:", e);
                  });
                // close Gen new report
              }else{
                let report_id;
                //Check ว่าเคยขอรายงานอยู่ในสถานะไหนหรือยัง
                ServiceApi.post("get_approve_report_file_list", {
                  str_where: "company_id = "+ Cookies.get("companyid") +
                  " and operator_id = "+ Cookies.get("operator_id") +
                  " and project_id = "+ Cookies.get("project_id") +
                  " and area_id = '"+this.state.areaId + "' " +
                  " and vendor_id = " + this.state.vendorId +
                  " and period_id = " + this.state.periodId + str_where_check
                })
                  .then((res) => {
                    if (res.data.result.code === "P") {
                      let pass = 0;
                      let filename = "";
                      res.data.data.map((answer, i) => {
                        report_id = answer.id;
                        if(answer.approve_status == 0) {
                          pass = 1;
                        }
                        if(filename == ""){
                          filename = answer.file_name;
                        } else{
                          filename = filename +","+ answer.file_name;
                        }
                      })
                      if(pass == 1){
                          // Gen new report
                          let api = "get_job_summary_report_bts";
                          if (this.props.reportType === "Form_For_MA_Fiber_Subcontractor") {
                            api = "get_job_summary_report";
                          }
                          this.setState({loading: "block"})
                          ServiceApi.post(api, {
                            company_id: Cookies.get("companyid"),
                            operator_id: Cookies.get("operator_id"),
                            project_id: Cookies.get("project_id"),
                            area_id: this.state.areaId,
                            job_type_id: this.state.jobtypelist,
                            pay_type_id: this.state.payTypeId,
                            team_group_id: this.state.vendorId,
                            start_date: this.state.startDate + " 00:00:00",
                            end_date: this.state.endDate + " 23:59:59",
                            vendor_name: this.state.vendorName,
                            peroid_name: this.state.periodName
                          })
                            .then((res) => {
                              if (res.data.result.code === "P") {
                                console.log("download file:" + res.data.result.value);

                                let tmpZone = [];
                                let zoneCode = "";
                                let file = "";

                                this.setState({
                                  url: res.data.result.value.split(","),
                                  downloadReportMessage: "",
                                  loading: "none",
                                  downloadMessage: "block"
                                });

                                // update record approve_report_file_list case: gen report new
                                ServiceApi.post("update_record_approve_report_file_list", {
                                  company_id: Cookies.get("companyid"),
                                  operator_id: Cookies.get("operator_id"),
                                  project_id: Cookies.get("project_id"),
                                  area_id: this.state.areaId,
                                  job_type_id: this.state.jobtypelist,
                                  pay_type_id: this.state.payTypeId,
                                  team_group_id: this.state.vendorId,
                                  start_date: this.state.startDate,
                                  end_date: this.state.endDate,
                                  period_id: this.state.periodId,
                                  create_user: Cookies.get("username"),
                                  report_id: report_id
                                })
                                  .then((res) => {
                                    console.log("update record report file list case:gen report new");
                                  })
                                  .catch((e) => {
                                    console.log("error update record report file list case:gen report new", e);
                                  });
                                console.log("url:" + this.state.url);
                              } else {
                                this.notify(
                                  "info",
                                  "Informaton",
                                  "Is Empty. " + res.data.result.value
                                );
                                this.setState({ downloadReportMessage: res.data.result.value,loading: "none",downloadMessage: "block" });
                              }
                            })
                            .catch((e) => {
                              console.log("error generating report:", e);
                            });
                          // close Gen new report
                      }else {// pass = 0
                        console.log('load old report to display');
                        const tmp = filename.split(",");
                        this.setState({url : []});
                        tmp.map((item, index) => (
                          //console.log("item:" + item + "  domainReport: "+domainReport)
                          this.setState(prevState => ({
                            url: [...prevState.url, domainReport+"Monthly_Report_BTS/"+item]
                          }))
                        ));
                        filename = "";
                        this.setState({
                          downloadReportMessage: "",
                          loading: "none",
                          downloadMessage: "block"
                        });
                        this.notify("info", "Informaton", "Can't re gen report please wait approve report.");
                      }
                    }

                  })
                  .catch((e) => {
                    console.log("error check approve report file list", e);
                  });
                //Close check ว่าเคยขอรายงานแล้วหรือยัง อยู่สถานะไหน

              }

            }
          });

      } else {
        // gen report
        // Gen new report
        let api = "";
        if (this.props.reportType === "Fault_Monthly_Material_Report") {
          api = "get_ma_summary_report";
        } else if (this.props.reportType === "Maintenance_Location_Report") {
          api = "get_maintenance_location_report";
        }
        this.setState({loading: "block"})
        ServiceApi.post(api, {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          area_id: this.state.areaId,
          job_type_id: this.state.jobtypelist,
          pay_type_id: this.state.payTypeId,
          team_group_id: this.state.vendorId,
          start_date: this.state.startDate + " 00:00:00",
          end_date: this.state.endDate + " 23:59:59",
          vendor_name: this.state.vendorName,
        })
          .then((res) => {

            if (res.data.result.code === "P") {

              this.setState({
                url: res.data.result.value.split(","),
                downloadReportMessage: "",
                loading: "none"
              });


            } else {
              this.notify(
                "info",
                "Informaton",
                "Is Empty. " + res.data.result.value
              );
              this.setState({ downloadReportMessage: res.data.result.value,loading: "none" });
            }
          })
          .catch((e) => {
            console.log("error generating report:", e);
          });
        // close Gen new report

      }

    }
  };

  setDisplayJobTypeList(){
    this.setState({optionJobType:"block"})
  }

  clickALLJobType(e){
    if(this.state.statusCheckJobTypeListAll == "No"){
      this.setState({statusCheckJobTypeListAll: "Yes"})
    } else {
      this.setState({statusCheckJobTypeListAll: "No"})
    }
  }

  handleOnChangeClickOption = (item , e) => {
    var jobtype = this.state.jobtypelist;
    var checknow = e.target.value;
    var jobtypeAll = "";
    if(checknow == "NULL"){
      for(let i = 0 ; i < this.state.data_job_type.length ; i++){
        this.state.data_job_type[i]["checkbox"] = e.target.checked ;
        if(jobtypeAll == ""){
          jobtypeAll = this.state.data_job_type[i]["job_type_id"];
        }else{
          jobtypeAll = jobtypeAll + "," + this.state.data_job_type[i]["job_type_id"];
        }
      }
      this.setState({
        checkbox_all :  e.target.checked ,
        data_job_type : this.state.data_job_type,
        jobtypelist : jobtypeAll
      });
    }else{
      item.checkbox = !item.checkbox;
      const result = this.state.data_job_type.filter(word => word.checkbox === true);
      this.setState({
        checkbox_all : result.length ===  this.state.data_job_type.length ? true : false ,
        data_job_type : this.state.data_job_type
      })
      if((e.target.checked == false) && (jobtype!="")){
        var b = jobtype.replace(","+checknow,"");
        var a = b.replace(checknow+",","");
        this.setState({jobtypelist: a});
      } else {

        if(jobtype == ""){
          this.setState({jobtypelist : e.target.value});
        }else{
          this.setState({jobtypelist : this.state.jobtypelist+","+checknow});
        }
      }
    }
    jobtype = "";
  }

  render() {
    const locale = Cookies.get("locale");
    /*
    urldownload = url.split(",");
    console.log('urldownload:'+urldownload);
    */

    return (

      <div>
        <div className="form-group row">
          <label className="col-12 col-sm-3 col-form-label text-right">
            {this.props.langUpdate
              ? this.props.langData[locale]["areaName"]
              : "Area name"}{" "}
            :
          </label>
          <div className="col-12 col-sm-6 col-form-input">
            <Select
              className="w-100"
              showSearch
              placeholder="Select area"
              value={this.state.areaId}
              onSelect={this.setArea}
            >
              <Option value="NULL" className="default-thai-font">
                ALL Area
              </Option>
              <Option value="BK%" className="default-thai-font">
                ALL_BKK
              </Option>
              {this.props.areaCode.map((item, index) => (
                <Option value={item.area_code} key={index}>
                  <span className="default-thai-font">{item.area_code}</span>
                </Option>
              ))}
            </Select>
          </div>
        </div>
        {this.props.reportType !== "Maintenance_Location_Report" ? (
          <div className="form-group row">
            <label className="col-12 col-sm-3 col-form-label text-right">
              {this.props.langUpdate
                ? this.props.langData[locale]["vendor"]
                : "Vendor"}{" "}
              :
            </label>
            <div className="col-12 col-sm-6 col-form-input">
              <Select
                className="w-100"
                showSearch
                placeholder="Select vendor"
                value={this.state.vendorName}
                onSelect={this.setVendor}
              >
                {this.state.vendorList.map((item, index) => (
                  <Option
                    value={`${item.vendor_id}_${item.team_group_name}`}
                    key={index}
                  >
                    <span className="default-thai-font">
                      {item.team_group_name}
                    </span>
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        ) : null}

        {this.state.CheckDisplayJobType ? (
          <div className="form-group row">
            <label className="col-12 col-sm-3 col-form-label text-right">
              {this.props.langUpdate
                ? this.props.langData[locale]["jobType"]
                : "Job Type"}{" "}
              :
            </label>
            <div className="col-12 col-sm-6 col-form-input">
                <div className="App jobTypeList" >
                <div className="row" style={{overflow: "hidden", display: "block"}} 
                onClick={()=> this.setDisplayJobTypeList()}>
                  <div className="row m-0 pl-1" style={{color:"#b9b9b9"}}>Select job type:
                  <span className="col-right-element pt-1 pr-2"><i className={this.state.actionListJobType}></i></span>
                  </div>
                </div>
                <div style={{"display":this.state.optionJobType}} >
                <div className="topping row">
                  <input className="col-right-element option-all outline-none-checkbox"
                  type="checkbox"
                  value="NULL"
                  checked={this.state.checkbox_all}
                  onChange={(e)=>this.handleOnChangeClickOption(this.props.jobType , e)}
                />
                <span className="default-thai-font">ALL</span>
                </div>
                {this.state.data_job_type.map((item, index) => (
                  <div className="topping row"  key={index}>
                  <input className="col-right-element option-all outline-none-checkbox"
                  type="checkbox"
                  id="jobtype"
                  name="jobtype"
                  value={item.job_type_id}
                  checked={item.checkbox}
                  onChange={(e)=>this.handleOnChangeClickOption(item , e)
                  }
                />
                <span className="default-thai-font">{item.job_type_name}</span>
                </div>
                ))}
                </div>

                </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CheckDisplayPayType ? (
          <div className="form-group row">
            <label className="col-12 col-sm-3 col-form-label text-right">
              {this.props.langUpdate
                ? this.props.langData[locale]["payType"]
                : "Pay Type"}{" "}
              :
            </label>
            <div className="col-12 col-sm-6 col-form-input">
              <Select
                className="w-100"
                showSearch
                placeholder="Select pay type"
                value={this.state.payTypeId}
                onChange={this.setPayType}
              >
                {this.props.payType.map((item, index) => (
                  <Option value={item.payId} key={index}>
                    <span className="default-thai-font">{item.payName}</span>
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        ) : null}
        <div className="form-group row">
          <label className="col-12 col-sm-3 col-form-label text-right">
            {this.props.langUpdate
              ? this.props.langData[locale]["startDate"]
              : "-"}{" "}
            :
          </label>
          <div className="col-12 col-sm-3 col-form-input">
            <ConfigProvider locale={locale}>
              <DatePicker
                format={"YYYY-MM-DD"}
                style={{ width: 120 }}
                placeholder={this.state.startDate}
                onChange={(date, dateString) => this.setStartDate(dateString)}
                defaultValue={moment(this.state.startDate, "YYYY-MM-DD")}
              />
            </ConfigProvider>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-12 col-sm-3 col-form-label text-right">
            {this.props.langUpdate
              ? this.props.langData[locale]["enddate"]
              : "-"}{" "}
            :
          </label>
          <div className="col-12 col-sm-3 col-form-input">
            <ConfigProvider locale={locale}>
              <DatePicker
                format={"YYYY-MM-DD"}
                style={{ width: 120 }}
                placeholder={this.state.endDate}
                onChange={(date, dateString) => this.setEndDate(dateString)}
                defaultValue={moment(this.state.endDate, "YYYY-MM-DD")}
                disabledDate={d => !d || d.isSameOrBefore(moment(this.state.startDate).add(-1,"day"))}
              />
            </ConfigProvider>
          </div>
        </div>
        {((this.props.reportType === "Form_For_MA_Fiber_Subcontractor") || (this.props.reportType === "Fault_Monthly_Report")) ?

          <div className="form-group row">
            <label className="col-12 col-sm-3 col-form-label text-right">
              {this.props.langUpdate
                ? this.props.langData[locale]["periodReport"]
                : "Period Report"}{" "}
              :
            </label>
            <div className="col-12 col-sm-6 col-form-input">
              <Select
                style={{width:"120px"}}
                showSearch
                placeholder="Select period"
                value={this.state.periodId+"_"+this.state.periodName}
                onSelect={(value)=>this.setPeriodReport(value)}
              >

                {this.state.periodList.map((item, index) => (
                  <Option
                    value={`${item.period_id}_${item.period_name}`}
                    key={index}
                  >
                    <span className="default-thai-font">
                      {item.period_name}
                    </span>
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          : ""}

        <div className="form-group row">
          {this.state.downloadReportMessage == "" ?
          (
            <div className="col-12 col-sm-6 offset-sm-3" style={{display:this.state.downloadMessage}}>
            {
              this.state.url.map((val,index) =>
              (
                <a href={val} target="_blank" key={index}> | Download {index+1} |</a>
              ))
            }
            </div>
          ) : <span className="text-danger">
          {this.state.downloadReportMessage}
        </span>}
          <div className="col-12 col-form-input text-center mt-3">
            <button
              className="btn btn-xs"
              onClick={this.clearSelect}
              style={{
                backgroundColor: "#e8ecef",
                marginRight: 30,
                width: 120,
              }}
            >
              <span>Clear</span>
            </button>
            <button
              className="btn btn-xs btn-primary"
              onClick={this.genExcel}
              style={{ width: 120 }}
            >
              <span>Confirm</span>
            </button>
          </div>

        </div>
        <div style={{position:"absolute",top:"10%",alignContent:"center",marginLeft:"-10%",width:"100%"}}><Spin style={{display: this.state.loading}} indicator={antIcon} /></div>
      </div>
    );
  }
}

export default FaultMonthlyReport;
